import { render, staticRenderFns } from "./ChangePasswordModule.vue?vue&type=template&id=a117e024&scoped=true&"
import script from "./ChangePasswordModule.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModule.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordModule.vue?vue&type=style&index=0&id=a117e024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a117e024",
  null
  
)

export default component.exports